

const initialState = {
    toasts: [],
    toastCounter: 0,
};

const mutations= {
    addToast(state, toast) {
        toast.id = initialState.toastCounter++;
        state.toasts.push(toast);
    },
    clearToast(state, title) {
        let index = 0;
        while (index !== -1) {
            console.log("Looking for title: ", title);
            index = state.toasts.findIndex((toast) => toast.title === title);
            console.log("Found: ", index);
            if (index !== -1) {
                console.log("Deleting index, it remains: ", state.toasts);
                state.toasts.splice(index,1); // remove toast from array
            }
        }
    },
    clearToastById(state, id) {
        const index = state.toasts.findIndex((toast) => toast.id === id);
        state.toasts.splice(index, 1);
    }
};

const getters = {
};

const actions = {
};

export default {
    namespaced: true,
    state: initialState,
    mutations: mutations,
    getters: getters,
    actions: actions,

}